import React, { useState } from "react";
import glogo from "../Images/glogo.png";
import "./Navbar.css";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <nav className="bg-sky-50 border-gray-400 logo-text-wrapper">
        <div className="max-w-screen-xl flex justify-between items-center mx-auto p-3 w-full relative">
          {/* Logo & Brand Name */}
          <a className="flex items-center ">
            <img
              src={glogo}
              className="h-14"
              alt="GeeCom Logo"
              loading="lazy"
            />
            <span className="text-2xl font-semibold whitespace-nowrap text-teal-600">
              GeeCom India
            </span>
          </a>

          {/* Centered Menu for Desktop */}
          <ul className="hidden md:flex space-x-6 absolute left-1/2 transform -translate-x-1/2 text-gray-700 font-medium">
            <li>
              <a href="#home" className="hover:text-teal-600">
                Home
              </a>
            </li>
            <li>
              <a href="#about" className="hover:text-teal-600">
                About
              </a>
            </li>
            <li>
              <a href="#services" className="hover:text-teal-600">
                Services
              </a>
            </li>
            <li>
              <a href="#features" className="hover:text-teal-600">
                Features
              </a>
            </li>
            <li>
              <a href="#contact" className="hover:text-teal-600">
                Contact Us
              </a>
            </li>
          </ul>

          {/* Mobile Menu Button */}
          <div className="flex items-center gap-4">
            <div className="translate-wrapper">
              <div id="google_translate_element"></div>
            </div>

            <button
              className="text-gray-700 md:hidden"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d={
                    menuOpen
                      ? "M6 18L18 6M6 6l12 12"
                      : "M4 6h16M4 12h16M4 18h16"
                  }
                />
              </svg>
            </button>
          </div>
        </div>
      </nav>

      {/* Sidebar Menu */}
      <div className={`mobile-sidebar ${menuOpen ? "open" : ""}`}>
        <ul className="flex flex-col space-y-4 text-gray-700 font-medium p-6">
          <li>
            <a
              href="#home"
              className="hover:text-teal-600"
              onClick={() => setMenuOpen(false)}
            >
              Home
            </a>
          </li>
          <li>
            <a
              href="#about"
              className="hover:text-teal-600"
              onClick={() => setMenuOpen(false)}
            >
              About
            </a>
          </li>
          <li>
            <a
              href="#services"
              className="hover:text-teal-600"
              onClick={() => setMenuOpen(false)}
            >
              Services
            </a>
          </li>
          <li>
            <a
              href="#features"
              className="hover:text-teal-600"
              onClick={() => setMenuOpen(false)}
            >
              Features
            </a>
          </li>
          <li>
            <a
              href="#contact"
              className="hover:text-teal-600"
              onClick={() => setMenuOpen(false)}
            >
              Contact Us
            </a>
          </li>
        </ul>
      </div>
    </>
  );
}
